import { LOGIN_FAILIED_STYLE } from "../../utils/GlobalConstants";
import { LOGIN_FAILED_ERR } from "../../utils/GlobalMessageConstants";

const LoginFailed = () => {
  return <div style={LOGIN_FAILIED_STYLE}>{LOGIN_FAILED_ERR}</div>;
};
export default LoginFailed;
